import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (token) {
      verifyEmail();
    }
  }, [token]);

  const verifyEmail = async () => {
    try {
      const res = await api.post(`/auth/verify-email/${token}`);
      setStatus('success');
      setMessage(res.data.message || 'Email verified successfully!');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.detail || 'Verification failed. The link may be expired or invalid.');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          {status === 'verifying' && (
            <>
              <Loader2 className="w-16 h-16 text-blue-600 animate-spin mx-auto mb-4" data-testid="verify-loading" />
              <h1 className="text-2xl font-bold text-slate-900 mb-2">Verifying Email</h1>
              <p className="text-slate-600">Please wait while we verify your email address...</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-4" data-testid="verify-success-icon" />
              <h1 className="text-2xl font-bold text-slate-900 mb-2">Email Verified!</h1>
              <p className="text-slate-600 mb-4">{message}</p>
              <p className="text-sm text-slate-500">Redirecting to login in 3 seconds...</p>
            </>
          )}
          
          {status === 'error' && (
            <>
              <XCircle className="w-16 h-16 text-rose-600 mx-auto mb-4" data-testid="verify-error-icon" />
              <h1 className="text-2xl font-bold text-slate-900 mb-2">Verification Failed</h1>
              <p className="text-slate-600 mb-6">{message}</p>
              <div className="space-y-3">
                <Button 
                  onClick={() => navigate('/login')} 
                  className="w-full bg-blue-600 hover:bg-blue-700"
                  data-testid="go-to-login-btn"
                >
                  Go to Login
                </Button>
                <p className="text-sm text-slate-500">
                  Need a new verification link? Try logging in and we'll help you resend it.
                </p>
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
